import AppLogResourceModel from '../../generated/types/model/resource/AppLogResourceModel';

export default class AppLogResourceViewModel extends AppLogResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
